// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.setting-menu {
  position: absolute;
  background: white;
  color: black;
  right: 0px;
  top: 115%;
  /* padding:5px; */
  border-radius: 3px;
  box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.75);
  width: max-content;
  z-index: 100000000000000;
}

.dot-menu-flip {
  top: -150px;
}`, "",{"version":3,"sources":["webpack://./../common/src/Components/DynamicForm/components/formbuilder/Setting.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,iBAAA;EACA,YAAA;EACA,UAAA;EACA,SAAA;EACA,iBAAA;EACA,kBAAA;EACA,+CAAA;EAEA,kBAAA;EACA,wBAAA;AAAF;;AAGA;EACE,WAAA;AAAF","sourcesContent":[".setting-menu {\n  position: absolute;\n  background: white;\n  color: black;\n  right: 0px;\n  top: 115%;\n  /* padding:5px; */\n  border-radius: 3px;\n  box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.75);\n  // width: 150px;\n  width: max-content;\n  z-index: 100000000000000;\n}\n\n.dot-menu-flip {\n  top: -150px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
